export const daysOfWeek = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];
export const dayMapping = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6
};

export const processLessons = (lessons, type, googleMeetLink = "", currentWeek = new Date()) => {
  const dayNameMapping = {
    "monday": 0, "tuesday": 1, "wednesday": 2, "thursday": 3,
    "friday": 4, "saturday": 5, "sunday": 6,
    "Пн": 0, "Вт": 1, "Ср": 2, "Чт": 3, "Пт": 4, "Сб": 5, "Нд": 6
  };

  if (!lessons || !Array.isArray(lessons)) return [];
  
  return lessons.flatMap((lesson) => {
    if (!lesson) return [];
    
    // 1. Сначала проверяем ЯВНЫЕ отмены (type === 'cancel')
    if (lesson.type === 'cancel') {
      const dayName = lesson.lessonReschedule?.day?.toLowerCase() || "monday";
      const day = dayNameMapping[dayName] || 0;
      const [hours = 0, minutes = 0] = (lesson.lessonReschedule?.time?.split(":") || ["00", "00"]).map(Number);
      
      return {
        name: lesson.studentName || "",
        studentId: lesson.student_id || "",
        day,
        hour: hours,
        minute: minutes,
        time: lesson.lessonReschedule?.time || "00:00",
        type: 'cancel', 
        googleMeetLink,
        weekStartDate: lesson.weekStartDate
      };
    }
    
    // 2. Обработка перенесённых уроков / замен
    if (type === "Reschedule" && lesson.lessonReschedule) {
 
      const dayName = lesson.lessonReschedule.day?.toLowerCase() || "monday";
      const day = dayNameMapping[dayName] || 0;
      const [hours = 0, minutes = 0] = (lesson.lessonReschedule.time?.split(":") || ["00", "00"]).map(Number);
      
      return {
        _id: lesson._id,
        name: lesson.studentName || "",
        studentId: lesson.student_id || "",
        day,
        hour: hours,
        minute: minutes,
        time: lesson.lessonReschedule.time || "00:00",
        type: lesson.type  === "teacher-changed" ? 'Substitute' : lesson.type === "cancel" ? "cancel" : "Reschedule Lesson", 
        googleMeetLink,
        ageGroup: lesson.ageGroup,
        englishLevel: lesson.englishLevel,
        weekStartDate: lesson.weekStartDate
      };
    }
    
    // 3. Регулярные/пробные уроки
    if (lesson.classSchedule && Array.isArray(lesson.classSchedule)) {
      
      return lesson.classSchedule.map((schedule) => {
        const dayName = schedule.day?.toLowerCase() || "monday";
        const day = dayNameMapping[dayName] || 0;
        const [hours = 0, minutes = 0] = (schedule.time?.split(":") || ["00", "00"]).map(Number);
        
        return {
          name: lesson.name || lesson.studentName || "",
          studentId: lesson.studentId || "",
          day,
          hour: hours,
          minute: minutes,
          time: schedule.time || "00:00",
          type,
          googleMeetLink,
          ageGroup: lesson.ageGroup,
          englishLevel: lesson.englishLevel,
          weekStartDate: currentWeek
        };
      }).filter(Boolean);
    }
    
    return [];
  });
};